import clsx from 'clsx'
import styles from './NVButton.module.scss'

export const NVButton = ({
  variant = 'action',
  text,
  height,
  width,
  disabled,
  classes = {},
  style = {},
  stretchContent = false,
  onClick,
  type = 'button',
  ariaLabel,
  icon,
}: any) => {
  const buttonVariants = {
    action: styles['btn--action'],
    primary: styles['btn--primary'],
    primaryGrey: styles['btn--primary-grey'],
    secondary: styles['btn--cancel'],
    text: styles['btn--text'],
    iconOnly: styles['btn--icon-only'],
  }

  return (
    <button
      type={type}
      style={{ height, width, ...style.container }}
      className={clsx(styles['btn'], buttonVariants[variant], classes.container, {
        [styles['btn--disabled']]: disabled,
      })}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel || text}
    >
      <div
        style={{ ...style.content }}
        className={clsx(styles['btn__content'], classes.content, { [styles['btn__center-text']]: !stretchContent })}
      >
        {icon && <span className={styles['btn__icon']}>{icon}</span>}
        {text && <div>{text}</div>}
      </div>
    </button>
  )
}
